import React, { useState } from 'react';
import { ActivitySection } from './dashboard/ActivitySection';
import { ConversionSection } from './dashboard/ConversionSection';
import { PipelineSection } from './dashboard/PipelineSection';
import { ResultsSection } from './dashboard/ResultsSection';
import { LayoutDashboard, Activity, Filter, PieChart, BarChart3 } from 'lucide-react';
export function Dashboard() {
  const [activeTab, setActiveTab] = useState<'all' | 'activity' | 'conversion' | 'pipeline' | 'results'>('all');
  const tabs = [{
    id: 'all',
    label: 'Overview',
    icon: LayoutDashboard
  }, {
    id: 'activity',
    label: 'Activity',
    icon: Activity
  }, {
    id: 'conversion',
    label: 'Conversion',
    icon: Filter
  }, {
    id: 'pipeline',
    label: 'Pipeline',
    icon: BarChart3
  }, {
    id: 'results',
    label: 'Results',
    icon: PieChart
  }] as const;
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900" data-id="element-1">
      {/* Sticky Header */}
      <header className="sticky top-0 z-50 bg-[#0F2044] text-white shadow-md" data-id="element-2">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3">
          <div className="flex items-center justify-between h-16" data-id="element-4">
            <div className="flex items-center gap-2" data-id="element-5">
              <div className="bg-white/10 p-1.5 rounded-lg" data-id="element-6">
                <LayoutDashboard className="h-6 w-6 text-white" data-id="element-7" />
              </div>
              <span className="text-xl font-bold tracking-tight" data-id="element-8">
                LenderLens
              </span>
            </div>
            <div className="text-sm text-slate-300" data-id="element-9">
              Performance Dashboard • October 2023
            </div>
          </div>

          {/* Navigation Tabs */}
          <div className="flex space-x-1 overflow-x-auto pb-0 hide-scrollbar" data-id="element-10">
            {tabs.map(tab => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`
                    flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap
                    ${isActive ? 'border-white text-white' : 'border-transparent text-slate-400 hover:text-slate-200 hover:border-slate-600'}
                  `} data-id="element-11">
                  <Icon className="h-4 w-4" data-id="element-12" />
                  {tab.label}
                </button>;
          })}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-13">
        <div className="space-y-12" data-id="element-14">
          {(activeTab === 'all' || activeTab === 'activity') && <ActivitySection data-id="element-15" />}
          {(activeTab === 'all' || activeTab === 'conversion') && <ConversionSection data-id="element-16" />}
          {(activeTab === 'all' || activeTab === 'pipeline') && <PipelineSection data-id="element-17" />}
          {(activeTab === 'all' || activeTab === 'results') && <ResultsSection data-id="element-18" />}
        </div>
      </main>
    </div>;
}